import React from "react";
import { signup } from "../service/ApiService";
import { Link } from "react-router-dom";
import { Container, Grid, Typography, TextField, Button } from "@mui/material";

export function SignUp() {
  // 유효성 검사
  //const [isName, setIsName] = useState<boolean>(false)
  //const [isEmail, setIsEmail] = useState<boolean>(false)
  //const [isPassword, setIsPassword] = useState<boolean>(false)
  //const [isPasswordConfirm, setIsPasswordConfirm] = useState<boolean>(false)

  const handleSubmit = (event) => {
    event.preventDefault();
    // 오브젝트에서 form에 저장된 데이터를 맵의 형태로 바꿔줌.
    const data = new FormData(event.target);
    const username = data.get("username");
    const password = data.get("password");
    const password2 = data.get("password2");

    /**/
    //const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,25}$/;
    const passwordRegex = /^(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{4,25}$/;
    if (!passwordRegex.test(password)) {
      //alert("숫자+영문자+특수문자 조합으로 8자리 이상 입력해주세요!");
      alert(
        "숫자, 특수문자 조합으로 4자리 이상 25자 이하로 패스워드를 입력해주세요."
      );
      return;
    }

    if (password === password2) {
    } else {
      alert("비밀번호가 일치하는지 확인해 주세요. ");
      return;
    }

    signup({ username: username, password: password }).then((response) => {
      //console.log(response);
      if (!response.username) {
        alert("있는 계정이므로 다른계정을 만들어 주세요.");
        return;
      } else {
        // 계정 생성 성공 시 login페이지로 리디렉트
        alert("계정이 생성되었습니다.");
        window.location.href = "/login";
      }
    });
  };

  return (
    <Container component="main" maxWidth="xs" style={{ marginTop: "8%" }}>
      <form noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography component="h1" variant="h5">
              계정 생성
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              autoComplete="fname"
              name="username"
              variant="outlined"
              required
              fullWidth
              id="username"
              label="아이디"
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              name="password"
              label="패스워드"
              type="password"
              id="password"
              autoComplete="current-password"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              name="password2"
              label="패스워드 확인"
              type="password"
              id="password2"
              autoComplete="current-password"
            />
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" fullWidth variant="contained" color="primary">
              계정 생성
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Link to="/login" variant="body2">
              이미 계정이 있습니까? 로그인 해주세요.
            </Link>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

export default SignUp;
